<template>
    <div class="layout-head">
        <div class="head">
            <span class="logo">
                <router-link to="/"><img class="logo-show" v-show="logoType" src="../assets/icon/logo_show-new@2x.png" alt=""></router-link>
                <template v-if="logoCode == 1">
                    <router-link to="/"><img class="logo-hide" v-show="!logoType" src="../assets/icon/logo_hide.png" alt=""></router-link>
                </template>
                <template v-else>
                    <router-link to="/"><img class="logo-hide" v-show="!logoType" src="../assets/icon/logo_hide.png" alt=""></router-link>
                </template>
            </span>
            <div class="menu-btn">
                <img @click="toggle" v-show="type" class="close" src="../assets/icon/close.png" alt="">
                <img @click="toggle" v-show="!type" class="open" src="../assets/icon/icon_catalog.png" alt="">
            </div>
        </div>
        <Menu :type="type" @toggle="toggle"/>
    </div>
</template>
<script>
import Menu from './menu'
export default {
    components: {
        Menu
    },
    props: {
        logoCode: {
            type: Number,
            default: 1,
        },
        changeLogo: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            logoType: this.changeLogo,
            type: false
        }
    },
    mounted() {
        this.scrollIng();
    },
    watch: {
        changeLogo(newVal) {
            this.logoType = newVal
        }
    },
    methods: {
        toggle() {
            this.type = !this.type;
        },
        scrollIng() {
            const dom = document.querySelector('.node-anchor');
            const _this = this;
            if (dom) {
                window.onscroll= function() {
                    // const e = event || window.event;
                    const top = dom.offsetTop;
                    const sTop = parseInt(window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop);
                    if (sTop > top - 100) {
                        _this.logoType = false;
                    } else {
                        _this.logoType = true;
                    }
                }
            }
        }
    }
}
</script>

<style lang="less">
.layout-head {
    position: fixed;
    z-index: 5;
    left: 0;
    right: 0;
    .logo {
        top: 36px;
        left: 36px;
        position: absolute;
        z-index: 6;
        .logo-show {
            width: 106px;
            height: 36px;
        }
        .logo-hide {
            width: 44px;
            height: 44px;
            position: relative;
            top: -4px;
            left: -4px;
        }
    }

    .menu-btn {
        position: absolute;
        width: 50px;
        height: 50px;
        z-index: 6;
        top: 36px;
        right: 36px;
        cursor: pointer;
        img {
            width: 100%;
        }

        .close {
            transition: all ease-in .3s;
            &:hover {
                transform: rotate(180deg);
            }
        }
    }
}
</style>